<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="activityId" >
        <span slot="label" ><a-tooltip>{{$t('活动ID')}}<template slot="title">{{$t('活动ID')}}</template></a-tooltip> </span>
        <a-select v-model="form.activityId" :show-search="true" :placeholder="$t('请选择')+'活动'" :filter-option="false" @search="handleActivitySearch">
          <a-select-option v-for="activity in activityList" :key="activity.id" :value="activity.id">{{ activity.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="prizeName" >
        <span slot="label" ><a-tooltip>{{$t('奖品名称')}}<template slot="title">{{$t('奖品名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.prizeName" :maxLength="100" :placeholder="$t('请输入')+'奖品名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="prizeType" >
        <span slot="label" ><a-tooltip>{{$t('奖品类型')}}<template slot="title">{{$t('1谢谢参与2积分3优惠券4实物')}}</template></a-tooltip> </span>
        <a-select v-model="form.prizeType" :placeholder="$t('请选择')+'奖品类型'">
          <a-select-option :value="1">{{$t('谢谢参与')}}</a-select-option>
          <a-select-option :value="2">{{$t('积分')}}</a-select-option>
          <a-select-option :value="3">{{$t('优惠券')}}</a-select-option>
          <a-select-option :value="4">{{$t('实物')}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="scoreValue" v-if="form.prizeType === 2">
        <span slot="label" ><a-tooltip>{{$t('积分')}}<template slot="title">{{$t('积分')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.scoreValue" style="width: 100%" :min="0" :placeholder="$t('请输入')+'积分'" />
      </a-form-model-item>
      <a-form-model-item prop="couponId" v-if="form.prizeType === 3">
        <span slot="label" ><a-tooltip>{{$t('优惠券ID')}}<template slot="title">{{$t('优惠券ID')}}</template></a-tooltip> </span>
        <a-select v-model="form.couponId" :show-search="true" :placeholder="$t('请选择')+'优惠券'" :filter-option="false" @search="handleCouponSearch">
          <a-select-option v-for="coupon in couponList" :key="coupon.id" :value="coupon.id">{{ coupon.couponName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="productId" v-if="form.prizeType === 4">
        <span slot="label" ><a-tooltip>{{$t('商品 ID')}}<template slot="title">{{$t('商品 ID')}}</template></a-tooltip> </span>
        <a-select v-model="form.productId" :show-search="true" :placeholder="$t('请选择')+'商品'" :filter-option="false" @search="handleGoodsSearch">
          <a-select-option v-for="goods in goodsList" :key="goods.id" :value="goods.id">{{ goods.goodsName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="probability" >
        <span slot="label" ><a-tooltip>{{$t('中奖概率')}}<template slot="title">{{$t('中奖概率(万分比)')}}</template></a-tooltip> </span>
        <div style="display: flex; align-items: center;">
          <a-input-number v-model="form.probability" style="flex: 1;" :max="10000" :min="0" :placeholder="$t('请输入')+'中奖概率(万分比)'"/>
          <span style="margin-left: 10px; color: #666; font-size: 12px;">
            {{ $t('万分比') }} | {{ $t('剩余概率') }}: {{ remainingProbability }}
          </span>
        </div>
      </a-form-model-item>
      <a-form-model-item prop="stock" >
        <span slot="label" ><a-tooltip>{{$t('库存')}}<template slot="title">{{$t('库存')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.stock" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'库存'" />
      </a-form-model-item>
      <a-form-model-item prop="imageUrl" >
        <span slot="label" ><a-tooltip>{{$t('图片URL')}}<template slot="title">{{$t('图片URL')}}</template></a-tooltip> </span>
        <a-input v-model="form.imageUrl" :maxLength="255" :placeholder="$t('请输入')+'图片URL'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="description" >
        <span slot="label" ><a-tooltip>{{$t('描述')}}<template slot="title">{{$t('描述')}}</template></a-tooltip> </span>
        <a-input v-model="form.description" :maxLength="255" :placeholder="$t('请输入')+'描述'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" ><a-tooltip>{{$t('状态')}}<template slot="title">{{$t('状态')}}</template></a-tooltip> </span>
        <a-radio-group v-model="form.status" style="width: 100%">
          <a-radio :value="1">{{$t('启用')}}</a-radio>
          <a-radio :value="0">{{$t('禁用')}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { listLotteryPrize, getLotteryPrize, addLotteryPrize, updateLotteryPrize } from '@/api/lottery/lotteryPrize'
import { listCoupon } from '@/api/activity/coupon'
import { pageGoods } from '@/api/goods/goods'
import { listLotteryActivity } from '@/api/lottery/lotteryActivity'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        activityId: null,
        activityName: null,
        prizeName: null,
        prizeType: null,
        couponId: null,
        couponName: null,
        productId: null,
        goodsName: null,
        probability: null,
        stock: null,
        imageUrl: null,
        description: null,
        status: 0,
        createdAt: null,
        localeFieldMap:{},
      },
      couponList: [],
      goodsList: [],
      activityList: [],
      totalProbability: 0,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          prizeName: [{ required: true, message: this.$t('奖品名称')+this.$t('不能为空'), trigger: 'blur' }] ,
          prizeType: [{ required: true, message: this.$t('1谢谢参与2积分3优惠券4实物')+this.$t('不能为空'), trigger: 'change' }] ,
          probability: [{ required: true, message: this.$t('中奖概率')+this.$t('不能为空'), trigger: 'blur' }] ,
          stock: [{ required: true, message: this.$t('库存')+this.$t('不能为空'), trigger: 'blur' }] ,
          status: [{ required: true, message: this.$t('1启用 0禁用')+this.$t('不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict']),
  remainingProbability () {
    const current = this.form.probability || 0
    return Math.max(0, 10000 - this.totalProbability - current)
  }
  },
  validateProbability (value) {
    // 校验概率值不能超过剩余可用概率
    if (value > this.remainingProbability + (this.form.probability || 0)) {
      this.$message.warning('概率值超过可用剩余概率')
      this.form.probability = Math.min(value, this.remainingProbability + (this.form.probability || 0))
    }
  },
  watch: {
    'form.activityId': function (val) {
      if (val) {
        this.loadTotalProbability(val)
      }
    },
    'form.prizeType': function (val) {
      if (val === 3) {
        this.loadCouponList()
      } else if (val === 4) {
        this.loadGoodsList()
      }
    }
  },
  mounted () {
    this.loadActivityList()
  },
  methods: {
    moment,
    loadCouponList (keyword = '') {
      listCoupon({ couponName: keyword }).then(response => {
        if (response.code === '20001') {
          this.couponList = response.data
        }
      })
    },
    handleCouponSearch (value) {
      this.loadCouponList(value)
    },
    loadGoodsList (keyword = '') {
      pageGoods({ goodsName: keyword,"pageNum":1,"pageSize":20 }).then(response => {
        if (response.code === '20001') {
          this.goodsList = response.data.records
        }
      })
    },
    handleGoodsSearch (value) {
      this.loadGoodsList(value)
    },
    loadActivityList (keyword = '') {
      listLotteryActivity({ activityName: keyword,"noSixPrizes":true }).then(response => {
        if (response.code === '20001') {
          this.activityList = response.data
        }
      })
    },
    handleActivitySearch (value) {
      this.loadActivityList(value)
    },
    loadTotalProbability (activityId) {
      listLotteryPrize({ activityId: activityId }).then(response => {
        if (response.code === '20001') {
          let total = 0
          response.data.forEach(item => {
            if (item.id !== this.form.id) {
              total += item.probability || 0
            }
          })
          this.totalProbability = total
        }
      })
    },
    fillFormNames () {
      if (this.form.activityId) {
        const activity = this.activityList.find(item => item.id === this.form.activityId)
        if (activity) {
          this.form.activityName = activity.name
        }
      }
      if (this.form.couponId) {
        const coupon = this.couponList.find(item => item.id === this.form.couponId)
        if (coupon) {
          this.form.couponName = coupon.couponName
        }
      }
      if (this.form.productId) {
        const goods = this.goodsList.find(item => item.id === this.form.productId)
        if (goods) {
          this.form.productName = goods.goodsName
        }
      }
    },
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        activityId: null,
        activityName: null,
        prizeName: null,
        prizeType: null,
        couponId: null,
        couponName: null,
        productId: null,
        goodsName: null,
        probability: null,
        stock: null,
        imageUrl: null,
        description: null,
        status: 0,
        createdAt: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getLotteryPrize({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
        if (this.form.activityId) {
          this.loadTotalProbability(this.form.activityId)
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.fillFormNames()
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateLotteryPrize(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addLotteryPrize(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
